goog.provide("shadow.js.shim.module$$mui$material$Fab$default");
shadow.js.shim.module$$mui$material$Fab$default = shadow.js.shim.module$$mui$material$Fab.default;
